import * as React from 'react'
import { FC } from 'react'
import { SideDrawer } from '@sales-center/components'
import { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import { ReOrderSettingsForm } from './ReorderSettingsForm'
import { ENTITY_TYPES } from '@sales-center/common'

interface Props {
  onClose: () => void
  open: boolean
  settings: ICustomFieldFormSetting[]
  entityType: ENTITY_TYPES
}

export const ReOrderDrawer: FC<Props> = (props) => {
  const { onClose, open, settings, entityType } = props
  return (
    <SideDrawer
      title=" Re-Order Fields"
      onClose={onClose}
      open={open}
      width={550}
    >
      <ReOrderSettingsForm
        settings={settings}
        onClose={onClose}
        entityType={entityType}
      ></ReOrderSettingsForm>
    </SideDrawer>
  )
}

ReOrderDrawer.displayName = 'ReOrderDrawer'
